export const CANDIDATE_ID = 'candidateId';
export const CANDIDATE_PHOTO_URL = 'candidatePhotoUrl';
export const CANDIDATE_LAST_NAME = 'candidateLastName';
export const CANDIDATE_FIRST_NAME = 'candidateFirstName';
